export const UPLOAD_STATUS_WAIT = 'wait';
export const UPLOAD_STATUS_UPLOADING = 'uploading';
export const UPLOAD_STATUS_COMPLETE = 'complete';
export const UPLOAD_STATUS_CANCELED = 'canceled';
export const UPLOAD_STATUS_FAILED = 'failed';

export const MAX_STATUS_TITLE_LENGTH = 25;

export const CANCEL_ALL_UPLOAD_TEXT_TITLE = 'Cancel All Uploads?';
export const CANCEL_ALL_UPLOAD_TEXT_BODY =
  'Your uploads are not complete. Would you like to cancel all ongoing uploads?';
export const CANCEL_ALL_UPLOAD_TEXT_CANCEL_BUTTON = 'Cancel Uploads';
export const CANCEL_ALL_UPLOAD_TEXT_CONFIRM_BUTTON = 'Continue Uploads';

export const CANCEL_ITEM_UPLOAD_TEXT_TITLE = 'Cancel upload?';
export const CANCEL_ITEM_UPLOAD_TEXT_BODY = `Your uploads are not complete. Would you like to cancel {name}?`;
export const CANCEL_ITEM_UPLOAD_TEXT_CANCEL_BUTTON = 'Cancel Upload';
export const CANCEL_ITEM_UPLOAD_TEXT_CONFIRM_BUTTON = 'Continue Upload';

export const CANCEL_UPLOAD_PROGRESS_UPLOAD = 'FROM_PROGRESS_UPLOAD';
export const CANCEL_UPLOAD_LOGIN_AS = 'FROM_LOGIN_AS';
export const CANCEL_UPLOAD_LOGOUT = 'FROM_LOGOUT';

export const SUPPORT_AUDIO_EXT = ['.mp3', '.wav', '.aac', '.wma', '.flac', '.ogg'];

export const SUPPORT_UPLOAD_EXT = [
  '.mov',
  '.qt',
  '.mp4',
  '.m4v',
  '.mpg',
  '.mpeg',
  '.mpe',
  '.mpg',
  '.mpeg',
  '.avi',
  '.mts',
  '.m2ts',
  '.ts',
  '.m3u',
  '.m3u8',
  '.webm',
  '.wmv',
];

export const SUPPORT_UPLOAD_EXT_FOR_UPLOAD_VIDEO_DIALOG = [...SUPPORT_UPLOAD_EXT, ...SUPPORT_AUDIO_EXT];

export const UPLOAD_MODES_URL = 'UPLOAD_MODE_URL';
export const UPLOAD_MODES_CSV = 'UPLOAD_MODE_CSV';
export const UPLOAD_MODES_FILE = 'UPLOAD_MODE_FILE';

export const UPLOAD_FLOW_CREATE_VIDEO_VERSION = 'UPLOAD_FLOW_CREATE_VIDEO_VERSION';
